import { Link } from '@/domains/core/routing/components/Link';
import { GTM_CLICK_BRANDS } from '@/domains/productDiscovery/ProductPage/common/components/BrandLink/gtm';
import { discoverTheBrandStore } from '@/domains/productDiscovery/ProductPage/common/components/BrandLink/translation';
import { useBrand } from '@/domains/productDiscovery/ProductPage/modules/Brand/useBrand';

export const BrandLink = () => {
  const brand = useBrand();

  if (!brand.url || !brand.name) return null;

  const brandUrl = brand.url;
  const brandText = discoverTheBrandStore.format<string>({
    brandName: brand?.name,
  });

  const sendBrandLinkEvent = () =>
    GTM_CLICK_BRANDS(brandUrl, brandText as string);

  return (
    <Link
      href={brandUrl}
      className="text-small font-semibold underline"
      onClick={sendBrandLinkEvent}
    >
      {brandText}
    </Link>
  );
};
